import React from 'react';
import { Box } from '@mui/material';
import FieldRow from './FieldRow';
import LocalizedField from './LocalizedField';
import SectionBlock from './SectionBlock';

const titleCase = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : null);
const POSITION_NAMES = ['Left', 'Center', 'Right'];
const positionName = (positionId) => POSITION_NAMES[positionId] ?? `Position ${(positionId ?? 0) + 1}`;

export default function CustomBoothItemDetailPanel({ data, diffKeys = new Set(), side }) {
  if (!data) return null;

  const imageLinks = Array.isArray(data.correspondingMedia?.linkLocalizations) ? data.correspondingMedia.linkLocalizations : [];
  const links = Array.isArray(data.links) ? data.links : [];

  return (
    <Box>
      <SectionBlock title="Item Details" />
      <FieldRow
        label="Option Type"
        value={titleCase(data.optionType)}
        isChanged={diffKeys.has('optionType')}
        side={side}
      />

      <LocalizedField label="Name" fieldKey="localizedPairs" data={data.localizedPairs} diffKeys={diffKeys} side={side} />

      {(data.descriptionPairs?.values?.length > 0 || diffKeys.has('descriptionPairs')) && (
        <LocalizedField label="Description" fieldKey="descriptionPairs" data={data.descriptionPairs} diffKeys={diffKeys} side={side} />
      )}

      {imageLinks.length > 0 && (
        <>
          <SectionBlock title="Image" />
          {imageLinks.map((entry) => (
            <FieldRow
              key={entry.localeId ?? entry.mediaLink}
              label={`URL (${(entry.localeId ?? '').slice(0, 2).toUpperCase() || '?'})`}
              value={entry.mediaLink ?? '—'}
              isChanged={diffKeys.has('correspondingMedia')}
              side={side}
            />
          ))}
        </>
      )}

      {links.length > 0 && (
        <>
          <SectionBlock title="Links" />
          {links.map((link) => {
            const label = positionName(link.positionId);
            const thumbLinks = Array.isArray(link.thumbnailMedia?.linkLocalizations) ? link.thumbnailMedia.linkLocalizations : [];
            return (
              <React.Fragment key={link.id ?? link.positionId}>
                {link.externalLink && (
                  <FieldRow label={`${label} URL`} value={link.externalLink} isChanged={diffKeys.has('links')} side={side} />
                )}
                {thumbLinks.map((entry) => (
                  <FieldRow
                    key={entry.localeId ?? entry.mediaLink}
                    label={`${label} Thumbnail (${(entry.localeId ?? '').slice(0, 2).toUpperCase() || '?'})`}
                    value={entry.mediaLink ?? '—'}
                    isChanged={diffKeys.has('links')}
                    side={side}
                  />
                ))}
              </React.Fragment>
            );
          })}
        </>
      )}

      {(data.startDateTime || data.endDateTime) && (
        <>
          <SectionBlock title="Calendar" />
          <FieldRow
            label="Start"
            value={data.startDateTime ? new Date(data.startDateTime).toLocaleString() : null}
            isChanged={diffKeys.has('startDateTime')}
            side={side}
          />
          <FieldRow
            label="End"
            value={data.endDateTime ? new Date(data.endDateTime).toLocaleString() : null}
            isChanged={diffKeys.has('endDateTime')}
            side={side}
          />
        </>
      )}
    </Box>
  );
}
